<template>
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex flex-col w-full">
      <div class="flex flex-col gap-1">
        <span class="font-medium">איזה שירות?</span>
        <multi-select
          v-model="selectedServices"
          class="w-full"
          :options="services"
          :loading="servicesLoading"
          placeholder="ביחרו שירות"
          :showToggleAll="false"
          optionLabel="name">
          <template #option="slotProps">
            <span class="px-2">{{ slotProps.option.name }}</span>
          </template>
          <template #footer>
            <div class="py-2 px-3">
              נבחרו <strong>{{ selectedServices.length }} </strong> שירותים.
            </div>
          </template>
        </multi-select>
      </div>
    </div>

    <drawer-footer
      :approveLoading="loading"
      @approve-click="clickedAttachService"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { IService, ServiceType } from '@torim-app/types';

import { onMounted, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useAdminStore } from '@app/stores';
import { ServicesApi } from '@app/api/admin';
import { trackEvent } from '@app/composables/posthog';

const toast = useToast();
const adminStore = useAdminStore();

const emit = defineEmits(['close']);
const props = defineProps({
  providerId: {
    required: true,
    type: String
  },
})

const selectedServices = ref<IService[]>([]);
const loading = ref<boolean>(false);
const servicesLoading = ref<boolean>(true);
const services = ref<Array<IService>>([]);

const clickedAttachService = async () => {
  try {
    loading.value = true;
    await ServicesApi.attachServicesToProvider({
      providerId: props.providerId,
      servicesIds: selectedServices.value.map(x => x.id)
    });
    trackEvent('services_attached_to_provider', { count: selectedServices.value.length });
    toast.success('השירותים עודכנו בהצלחה.');
    await adminStore.fetchBusinessData();
  } catch (e) {
    console.error(e);
    toast.error('לא הצלחנו, אנא נסו שוב');
  } finally {
    loading.value = false;
    emit('close');
  }
}

onMounted(() => {
  ServicesApi.fetchAllServices()
    .then(res => {
      services.value.push(...res);
      selectedServices.value.push(...res.filter(x => x.providingClients.includes(props.providerId) && x.serviceType !== ServiceType.COMPLEMENTARY))
    })
    .catch((err) => {
      toast.error('לא הצלחנו לטעון את רשימת השירותים, אנא נסו שוב')
      console.error(`Failed at ServicesApi.fetchAllServices: ${err}`)
    }).
    finally(() => {
      servicesLoading.value = false;
    })
})

</script>
